/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import * as ACTIONTYPES from './actionTypes';

/**
 * Updates the form details of an application within the 'UAApplication' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function createApplicationUsingFormDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, ACTIONTYPES.CREATE_APPLICATION_USING_FORM_DETAILS);
}

/**
 * Updates the indicator that specifies whether form details of an application are being created or
 * not, for the 'UAApplication' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function isCreatingApplicationUsingFormDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ACTIONTYPES.CREATE_APPLICATION_USING_FORM_DETAILS);
}

/**
 * Updates the 'UAApplication' store object with any errors that may have occurred when creating
 * the form details of an application.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function createApplicationUsingFormDetailsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.CREATE_APPLICATION_USING_FORM_DETAILS);
}
var reducers = combineReducers({
  createApplicationUsingFormDetails: createApplicationUsingFormDetailsReducer,
  isCreatingApplicationUsingFormDetails: isCreatingApplicationUsingFormDetailsReducer,
  createApplicationUsingFormDetailsError: createApplicationUsingFormDetailsErrorReducer
});
export default {
  reducers: reducers
};